export default "__VITE_ASSET__cc534cb2__"